export default {
  components: {
    'TermsOfServices': 'TermsOfServicesEn',
  },
  termsOfServices: {
    title: 'Término de servicio',
  },
}
